import { render, staticRenderFns } from "./Fatturati.vue?vue&type=template&id=165da245&scoped=true"
import script from "./Fatturati.vue?vue&type=script&lang=js"
export * from "./Fatturati.vue?vue&type=script&lang=js"
import style0 from "./Fatturati.vue?vue&type=style&index=0&id=165da245&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165da245",
  null
  
)

export default component.exports